export const resources = [
    {
        name:"Master Solidity for blockchain",
        description:"Youtube Video",
        image:"https://assets.codepen.io/4722128/internal/avatars/users/default.png?fit=crop&format=auto&height=512&version=1594276253&width=512",
        url:"https://www.youtube.com/watch?v=pqxNmdwEHio&list=PLS5SEs8ZftgVnWHv2_mkvJjn5HBOkde3g"
     },{
        name:"How to Build Ethereum Dapp (DApp Tutorial)",
        description:"Youtube Video",
        image:"https://assets.codepen.io/4722128/internal/avatars/users/default.png?fit=crop&format=auto&height=512&version=1594276253&width=512",
        url:"https://www.youtube.com/watch?v=3681ZYbDSSk&list=PLS5SEs8ZftgUTXs0OJD2LFpYBPr4L54id"
     },{
        name:"How to use IPFS For Dapp Development",
        description:"Youtube Video",
        image:"https://assets.codepen.io/4722128/internal/avatars/users/default.png?fit=crop&format=auto&height=512&version=1594276253&width=512",
        url:"https://www.youtube.com/watch?v=ADoRVVOSpI8&list=PLS5SEs8ZftgWggD3tKfgwsIPXuIhorXZk"
     },{
        name:"Defi Programming Tutorials",
        description:"Youtube Video",
        image:"https://assets.codepen.io/4722128/internal/avatars/users/default.png?fit=crop&format=auto&height=512&version=1594276253&width=512",
        url:"https://www.youtube.com/watch?v=z9FgWvUai28&list=PLbbtODcOYIoGC8c5-gs0EYzpYVUPdmqO3"
     },
     {
        name:"A 101 Guide To Become Blockchain Developer",
        description:"Medium Blog",
        image:"https://assets.codepen.io/4722128/internal/avatars/users/default.png?fit=crop&format=auto&height=512&version=1594276253&width=512",
        url:"https://medium.com/@blockchainunmasked/a-101-guide-to-become-a-blockchain-developer-eba396aa00e"
     },
     {
        name:"Resourrces to Learn Blockchain",
        description:"Medium Blog",
        image:"https://assets.codepen.io/4722128/internal/avatars/users/default.png?fit=crop&format=auto&height=512&version=1594276253&width=512",
        url:"https://medium.com/free-code-camp/the-resources-i-used-to-teach-myself-blockchain-development-1fccada9b92b"
     },
     {
        name:"Transform Into a Web3, NFT, Developer",
        description:"Medium Blog",
        image:"https://assets.codepen.io/4722128/internal/avatars/users/default.png?fit=crop&format=auto&height=512&version=1594276253&width=512",
        url:"https://betterprogramming.pub/transform-into-a-web3-crypto-nft-and-blockchain-development-expert-5-resources-8fdd11037eb8"
     },
     {
        name:"The popular languages used for blockchain",
        description:"Medium Blog",
        image:"https://assets.codepen.io/4722128/internal/avatars/users/default.png?fit=crop&format=auto&height=512&version=1594276253&width=512",
        url:"https://medium.com/free-code-camp/the-most-popular-programming-languages-used-in-blockchain-development-5133a0a207dc"
     },
     {
        name:"Certified Enterprise Blockchain Professional",
        description:"Course",
        image:"https://assets.codepen.io/4722128/internal/avatars/users/default.png?fit=crop&format=auto&height=512&version=1594276253&width=512",
        url:"https://academy.101blockchains.com/courses/blockchain-expert-certification?sscid=11k6_z4qlt&"
     },
     {
        name:"Blockchain A-Z™: Learn How To Build DApps",
        description:"Course",
        image:"https://assets.codepen.io/4722128/internal/avatars/users/default.png?fit=crop&format=auto&height=512&version=1594276253&width=512",
        url:"https://www.udemy.com/course/build-your-blockchain-az/?ranMID=39197&ranEAID=CuIbQrBnhiw&ranSiteID=CuIbQrBnhiw-NCCI0plPljApv9x0LCvdEA&LSNPUBID=CuIbQrBnhiw&utm_source=aff-campaign&utm_medium=udemyads"
     },
     {
        name:"Blockchain Specialization",
        description:"Course",
        image:"https://assets.codepen.io/4722128/internal/avatars/users/default.png?fit=crop&format=auto&height=512&version=1594276253&width=512",
        url:"https://www.coursera.org/specializations/blockchain?ranMID=40328&ranEAID=JVFxdTr9V80&ranSiteID=JVFxdTr9V80-vPWkcsRloNitryXyCOC9yw&siteID=JVFxdTr9V80-vPWkcsRloNitryXyCOC9yw&utm_content=10&utm_medium=partners&utm_source=linkshare&utm_campaign=JVFxdTr9V80"
     },
     {
        name:"Become a Blockchain Developer",
        description:"Course",
        image:"https://assets.codepen.io/4722128/internal/avatars/users/default.png?fit=crop&format=auto&height=512&version=1594276253&width=512",
        url:"https://www.educative.io/courses/hands-on-blockchain-hyperledger-fabric?affiliate_id=5073518643380224"
     },
]